import type { Tab } from "./types";

export const APP_NAME = "Songbook.Studio";
export const APP_DESCRIPTION = `${APP_NAME} lets you create and share chords & lyrics with your friends.`;

export const NEW_SONG_TITLE = "New Song";
export const NEW_SONG_PLACEHOLDER = "[G]Chords are placed like [C]this.";

export const DOMAIN_NAME = "songbook.studio";

export const REPLICACHE_DB_NAME = `replicache-${APP_NAME}/schema2`;

export function getLocationOrigin() {
  if (typeof window !== "undefined" && window.location.origin) {
    return window.location.origin;
  }
  return `https://${DOMAIN_NAME}`;
}

const protocol = process.env.NODE_ENV === "development" ? "http" : "https";
const host =
  process.env.NODE_ENV === "development"
    ? "localhost:3000"
    : process.env.VERCEL_ENV === "production"
      ? DOMAIN_NAME
      : process.env.VERCEL_URL;
export const PROTOCOL_AND_HOST = `${protocol}://${host || DOMAIN_NAME}`;

export const SIGN_IN_HASH = "sign-in";

export const COLORS = {
  purple: {
    bright: "#9DA6FC",
    light: "#7C82EC",
    main: "#4553BC",
    dark: "#052F89",
  },
  white: {
    secondary: "rgba(255, 255, 255, 0.87)",
    tertiary: "rgba(255, 255, 255, 0.60)",
    quaternary: "rgba(255, 255, 255, 0.54)",
  },
};

export const SONGLIST_WIDTH = 384;
export const SONGLIST_SCROLLBAR_WIDTH = 8;
const HEADER_ICON_WIDTH = 48;
export const HEADER_TITLE_WIDTH =
  SONGLIST_WIDTH - HEADER_ICON_WIDTH - SONGLIST_SCROLLBAR_WIDTH;

export const UA = {
  isIOS: () =>
    typeof window !== "undefined" &&
    window.navigator &&
    window.navigator.platform &&
    /iPad|iPhone|iPod/.test(window.navigator.platform),
};

export const TABS: Tab[] = [
  { label: "Songs", value: "songlist" },
  { label: "Sets", value: "setlists" },
  { label: "Friends", value: "friends" },
];

export const chordColors: Record<string, string> = {
  A: "#F12F2F",
  B: "#F87554",
  C: "#FEBF44",
  D: "#3AFA92",
  E: "#29BFFF",
  F: "#7C82EC",
  G: "#F57BFF",
};
